import { useContext, useState } from "react";
import { CartContext } from "../context/CartContext";
import "./Payment.css";

const Payment = () => {
  const { clearCart } = useContext(CartContext);
  const [loading, setLoading] = useState(false);

  const orderData = JSON.parse(localStorage.getItem("orderData")) || {};

  const API_BASE =
    process.env.REACT_APP_API_URL ||
    "https://worobo-bk.onrender.com";

  const handleCheckout = async () => {
    try {
      setLoading(true);

      const res = await fetch(
        `${API_BASE}/api/create-checkout-session`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            customer: orderData.customer,
            items: orderData.items,
            total: orderData.total,
            orderMessage: orderData.orderMessage || "",
          }),
        }
      );

      const data = await res.json();

      if (!data.url) {
        alert("Stripe session failed");
        setLoading(false);
        return;
      }

      // Save order before redirect
      localStorage.setItem(
        "pendingOrder",
        JSON.stringify(orderData)
      );

      // Redirect to Stripe Checkout (NEW METHOD)
      window.location.href = data.url;

    } catch (err) {
      console.error("Payment error:", err);
      alert("Payment failed");
    }

    setLoading(false);
  };

  return (
    <div className="payment-container">
      <h2>Secure Payment</h2>

      <div className="stripe-box">
        <img
          src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/stripe.svg"
          alt="Stripe"
          className="stripe-logo"
        />

        <p>Pay securely with Stripe</p>

        <button
          className="pay-btn"
          onClick={handleCheckout}
          disabled={loading}
        >
          {loading ? "Redirecting..." : "Pay now"}
        </button>
      </div>
    </div>
  );
};

export default Payment;